import { API } from 'aws-amplify';

  
  export async function clientBlob(endpoint, { body, ...customConfig } = {}) {
    const headers = { 'Content-Type': 'application/json' }
  
    const config = {
      method: body ? 'POST' : 'GET',
      ...customConfig,
      headers: {
        ...headers,
        ...customConfig.headers,
      },
    }
  
    if (body) {
      config.body = JSON.stringify(body)
    }
    console.log("clientBlob config:",config)
    let data //, dataX
    try {
        const apiName = 'esc-api';
        // const path = endpoint 
        const queryStringParameters = config.queryStringParameters
        const params = { queryStringParameters };
         
      console.log("Get data params: ", params, endpoint, apiName)
      const res2 = await API.post(apiName, endpoint, params);
      console.log("res2 :",res2)
    //   const response = await window.fetch(endpoint, config)
    //      dataX = await response.json()
      // console.log(res2.status," : ", res2.headers, " : ", res2.url) 
      if (res2.success === 'false') {

        return Promise.reject(res2.errMsg ? res2.errMsg : res2)

      } else if (res2.length !== 0) {
        console.log("OK ",res2)
        //Return a result object similar to Axios

        // const ctx = new AudioContext();
        // var audio;
        // fetch(res2)
        //   .then(data => data.arrayBuffer())
        //   .then(arrayBuffer => ctx.decodeAudioData(arrayBuffer))
        //   .then(decodedAudio => {
        //     audio = decodedAudio;
        //   })

          // window.fetch(res2, {mode: 'no-cors'})
          //   .then(response => response.arrayBuffer())
          //   .then(arrayBuffer => ctx.decodeAudioData(arrayBuffer))
          //   .then(audioBuffer => {
          //     audio = audioBuffer;
          // });
        // data = downloadBlob(res2.Body)
        // data = res2.Body
        // console.log(audio.length)
        return {
          status: 200,
          data: res2,
          headers: {},
          url: `http://api/${endpoint}`,
        }
      }
      console.log("Help")
      throw new Error(res2.errMsg)
    } catch (err) {
      console.log("GET error :",err)
      return Promise.reject(err.message ? err.message : data)
    }
}

clientBlob.get = function (endpoint, customConfig = {}) {
  console.log("Getting blob")
  return clientBlob(endpoint, { ...customConfig, method: 'GET' })
}
